const DEFAULT_GUTTER = [8, 10];

export { DEFAULT_GUTTER };
//# sourceMappingURL=config2.js.map
